import { Flex } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';

import './adminNavigationMenu.scss';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { USER_ROLE } from 'constants/enums/user-roles';
import { RoleGuardComponent } from 'baseComponents/RoleGuardComponent';

const getLinkClassnames: NavLinkProps['className'] = ({ isActive }) =>
  `navigation-link ${isActive ? 'navigation-link-active' : ''}`;

export const AdminNavigationMenu = () => {
  const links = [
    {
      label: 'Business Credits',
      link: '/admin/business-credits',
      rolesAllowed: [USER_ROLE.admin, USER_ROLE.developer],
    },
    {
      label: 'Manage Users',
      link: '/admin/manage/users',
      rolesAllowed: [
        USER_ROLE.admin,
        USER_ROLE.developer,
        USER_ROLE.franchiseOwner,
      ],
    },
    {
      label: 'Manage Test Users',
      link: '/admin/manage/test-users',
      rolesAllowed: [
        USER_ROLE.admin,
        USER_ROLE.developer,
        USER_ROLE.franchiseOwner,
      ],
    },
    {
      label: 'Manage Test Users Push',
      link: '/admin/manage/test-users-push',
      rolesAllowed: [
        USER_ROLE.admin,
        USER_ROLE.developer,
        USER_ROLE.franchiseOwner,
      ],
    },
    {
      label: 'Manage Attributes',
      link: '/admin/manage/attributes',
      rolesAllowed: [
        USER_ROLE.admin,
        USER_ROLE.developer,
        USER_ROLE.franchiseOwner,
      ],
    },
    {
      label: 'Manage Stores',
      link: '/admin/manage/stores',
      rolesAllowed: [
        USER_ROLE.admin,
        USER_ROLE.developer,
        USER_ROLE.franchiseOwner,
      ],
    },
    {
      label: 'API Configuration',
      link: '/admin/api-configuration',
      rolesAllowed: [USER_ROLE.developer],
    },
    {
      label: 'Global Configuration',
      link: '/admin/global-configuration',
      rolesAllowed: [USER_ROLE.developer],
    },
  ];

  return (
    <div className='admin-navigation-wrapper'>
      <div className='navigation-title'>
        <TextComponent text='Admin Dashboard' weight='extra-bold' />
      </div>

      <Flex vertical>
        {links.map(({ label, link, rolesAllowed }) => (
          <RoleGuardComponent roles={rolesAllowed} key={label}>
            <NavLink to={link} className={getLinkClassnames}>
              {label}
            </NavLink>
          </RoleGuardComponent>
        ))}
      </Flex>
    </div>
  );
};
